"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    dataDimension: true
};
//# sourceMappingURL=organisationUnitGroupSet.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/d2/lib/model/config/model-defaults/organisationUnitGroupSet.js
// module id = 557
// module chunks = 0